export const cardFAQs = [
  {
    question: 'How can I apply for a Cypher Card?',
    answer:
      'You can apply for a Cypher Card by joining the waitlist using the form provided. We will send invite codes to the email address you provide.',
  },
  {
    question: 'How long does it take to complete the KYC process?',
    answer:
      'The KYC process usually takes up to 48 hours. If you experience any delays, please contact Cypher Support. Please note that we only accept documents in English, and passports have a higher acceptance rate.',
  },
  {
    question: 'How can I get a physical card?',
    answer:
      "To get a physical Cypher Card, you need to load a minimum amount of $500 to your virtual card. Please note that the minimum amount is subject to change in the future. Once you're eligible, you can apply for an upgrade to physical card. We will ship the card to anywhere in the world by deducting a nominal shipping fee based on your delivery location. You can use both cards with the same wallet balance.",
  },
  {
    question: 'How fast is shipping for Cypher Card?',
    answer:
      'Once you’re approved, we will issue your Cypher Virtual Card instantly. On loading 500 USD (subject to change) you will be eligible for a Physical Card. However, the shipping time of a physical card depends on your delivery address and usually takes up to 4 to 6 weeks. Also to note, you will receive 3 emails from FedEx with tracking number after 2 weeks of requesting a physical card, with details on estimated date of delivery and delivered status.',
  },
  {
    question: 'Does Cypher charge any fees?',
    answer:
      'No, we do not charge any joining or annual fees, and there are no transaction fees associated with Cypher Card.',
  },
  {
    question:
      'What are the conversion and foreign exchange rates for transactions made with the Cypher card?',
    answer:
      'For transactions made with the Cypher card, the conversion and foreign exchange rates are determined by MasterCard. No additional markup fees are applied by us.',
  },
  {
    question: 'Are there any limits on the Cypher Card?',
    answer:
      'Yes, there are limits on the Cypher Card. The daily limit is 4000 USD and the monthly limit is 7000 USD. However, both of these limits can be raised if needed. Also, there is a hard limit of 500 USD per day on ATM withdrawals, which cannot be changed. Please contact Cypher Support for more information on how to raise your limits.',
  },
  {
    question: 'Where can I use my Cypher Card?',
    answer:
      'You can use your Cypher Card all over the world and withdraw cash from ATMs. However, we do not support transactions on illegal activities such as gambling or drugs.',
  },
  {
    question: 'What are the fees for ATM withdrawals with Cypher Card?',
    answer:
      'ATM withdrawals using Cypher Card are subject to a fee of 1%, in addition to any charges imposed by the bank or ATM operator. Please note that there is a hard limit of 500 USD per day on ATM withdrawals, which cannot be changed.',
  },
  {
    question: 'How can I apply for a Cypher Card as a business?',
    answer:
      'If you want to use Cypher Card for your business, please contact Cypher Support for more information on joining as a business customer.',
  },
  {
    question: 'Why is there a fluctuation in the card balance?',
    answer: `This can happen due to fluctuations in the currency exchange rate between the authorization and settlement dates of the transaction.

      Here's a breakdown of the process:
      - Authorization: When you use your card to make a purchase, the merchant gets instant approval for the purchase amount.
      - Settlement: It takes some time for the final transaction amount to be settled between your bank and the merchant.
      
      Example:
      Imagine you buy something in Euros (EUR) using your Cypher Card (USD by default)
      - Authorization: At the time of purchase, the exchange rate might be 0.92 USD per 1 EUR, so the bank authorizes $92 (0.92 * 100 EUR).
      - Settlement: A few days later, on the settlement date, the rate might be 0.93 USD per 1 EUR. Therefore, the final amount debited from your account would be $93 (0.93 * 100 EUR).
      This slight difference in exchange rates can cause a minor fluctuation in your card balance.`,
  },
  {
    question:
      'Can the Cypher card be replaced, and what is the cost associated with its replacement?',
    answer:
      'Yes, you can replace your Cypher card (both virtual and physical). A replacement fee of $50 covers both shipping and production costs. Please contact our support team for assistance with the replacement process.',
  },
  // Add more FAQs as needed
];

export const faqs = [
  {
    question: 'What is Cypher?',
    content: (
      <p>
        Cypher is a multi-chain wallet for all your crypto and DeFi needs. You
        can swap, bridge, stake & earn track all your coins, browse dApps, and
        access your multi-chain NFTs from a single place.
      </p>
    ),
  },
  {
    question: 'How Secure is Cypher?',
    content: (
      <p>
        Cypher is a non-custodial wallet. i.e only you have sole control of your
        private keys. There is no need to trust a third party when using a
        non-custodial wallet, this also means that you are solely responsible
        for not losing your keys and requires that you take your own precautions
        to protect your funds.
      </p>
    ),
  },
  {
    question: 'What chains does Cypher support?',
    content: (
      <p>
        We're currently supporting Ethereum, Polygon, Avalanche, Binance Smart
        Chain, Fantom, Optimism, Arbitrum One, Base, zkSync Era, Polygon zkEVM,
        Shardeum, Evmos, Cosmos, Osmosis, Noble, Juno, and Stargaze.
      </p>
    ),
  },
  {
    question: 'How to contact support?',
    content: (
      <ul class='ml-6 list-disc'>
        <li>Open Cypher App.</li>
        <li>Tap on "Options" in the bottom right corner.</li>
        <li>Select "Support".</li>
        <li>
          "Start a conversation" and our team executive will respond to you.
        </li>
      </ul>
    ),
  },
  {
    question: 'What is a bridge?',
    content: (
      <p>
        Blockchain bridges work just like the bridges we know in the physical
        world. Just as a physical bridge connects two physical locations, a
        blockchain bridge connects two blockchain ecosystems. Bridges facilitate
        communication between blockchains through the transfer of information
        and assets.
      </p>
    ),
  },
  {
    question: 'How to Import my existing wallet?',
    content: (
      <div>
        <p>
          You can import your wallet with your seed phrase by using the "Import
          Wallet" option in Cypher.
        </p>
        <br />
        <ul class='ml-6 list-disc text-[14px]'>
          <li>Go to "Options"</li>
          <li>Click on "Manage Wallet"</li>
          <li>Select "Import Wallet"</li>
          <li>
            Enter the seed phrase of the wallet you want to import (or) simply
            scan the QR code.
          </li>
          <li>That's it! Your wallet will be imported.</li>
        </ul>
        <br />
        <p>
          Your Cypher wallet will have only one seed phrase independent of
          chains. You can use the same seed phrase for every chain supported by
          Cypher.
        </p>
      </div>
    ),
  },
  {
    question: 'How to use the browser for dApps on Cypher?',
    content: (
      <p>
        <ul class='ml-6 list-disc'>
          <li>Open Cypher App</li>
          <li>Select the "Browser" option in the bottom left corner.</li>
          <li>Enter the URL of the dApp you would like to browse.</li>
          <li>
            You can change the chains by clicking the chain logo on the upper
            right corner.
          </li>
        </ul>
      </p>
    ),
  },
  {
    question: 'How can I recover my wallet?',
    content: (
      <p>
        You can recover your Cypher Wallet by downloading the app again and
        inputting your seed phrase. This is the only way to recover your
        non-custodial wallet if you lose it. That's why it's extremely important
        to never lose your seed phrase. You can save the key offline to keep it
        safe.
      </p>
    ),
  },
  {
    question: 'What data does Cypher store?',
    content: (
      <p>
        Cypher never stores any sensitive information like SSN and address we
        collect while you are applying for the card. All of it is stored with
        our bank.
        <br />
        We do not know where you transact with your card.
      </p>
    ),
  },
  {
    question:
      'What is the difference between custodial and non-custodial wallets?',
    content: (
      <p>
        A <b>Custodial Wallet</b> is defined as a wallet in which the private
        keys are held by a third party. Meaning, the third party has full
        control over your funds while you only have to give permission to send
        or receive payments.
        <br />
        <br />A <b>Non-Custodial Wallet</b> is a type of Blockchain wallet that
        lets you be your own bank. This implies that users have full control
        over their funds and the associated private key.
      </p>
    ),
  },
  {
    question: 'What is a blockchain?',
    content: (
      <p>
        Blockchain is a system of recording information in a way that makes it
        difficult or impossible to change, hack, or cheat the system.
      </p>
    ),
  },
  {
    question: 'Where are assets stored on blockchain?',
    content: (
      <p>
        Digital assets are stored and recorded on the blockchain ledger where
        they were issued (in most cases). Your ledger entry has a public and
        private key associated with it, which you can think of like a
        computer-generated email address and password.
      </p>
    ),
  },
  {
    question: 'What is transaction signing flow?',
    content: (
      <p>
        Transaction signing in Cypher is to safeguard your wallet from
        unauthorized access by taking your approval for every transaction you
        want to perform.
      </p>
    ),
  },
];
